<template lang="pug">
  .advance-settings
    v-container.px-0(style="max-width:600px")
      v-layout.my-2
        div.mr-2
          v-icon.mt-1(left color="black" :size="24" @click="$router.push('/admin/clinic/settings')") mdi-arrow-left
        div.title.font-weight-bold {{ $t('section_integrations.title') }}
      
      //- Custom domain
      v-card.py-4.mt-4(flat outlined)
        .header.px-4
          div.s1.basic800--text {{ $t('section_integrations.domain') }}
          div.c1.basic600--text {{ $t('section_integrations.domain_desc') }}
        v-divider.my-4
        v-layout.mx-4.mt-4
          div.my-auto.s1.basic800--text {{ $t('section_integrations.custom_domain') }}
          v-spacer
          v-chip.button-AA-tiny.text-uppercase(label outlined color="black" small @click="openRequestCustDomain = true") {{ $t('manage') }}
        v-divider.my-4
        v-layout.mx-4.mt-4
          div.my-auto.s1.basic800--text {{ $t('section_integrations.domain_verifications') }}
          v-spacer
          v-chip.button-AA-tiny.text-uppercase(label outlined color="black" small @click="openDomainVerifications = true") {{ $t('manage') }}
      
      //- Webhook
      v-card.py-4.mt-4(flat outlined)
        v-layout.mx-4
          .header
            div.s1.basic800--text {{ $t('section_integrations.webhook') }}
            div.c1.basic600--text {{ $t('section_integrations.webhook_desc') }}
            div.c1.accent--text(@click="openLink('w')") {{ $t('learn_more') }}
          v-spacer
          v-chip.my-auto.button-AA-tiny.text-uppercase(label outlined color="black" small @click="openWebhookDialog()") {{ $t('manage') }}
    
    .modals
      update-webhook(v-if="showUpdateWebhookDialog" :open.sync="showUpdateWebhookDialog" :company="company")
      request-custom-domain(v-if="openRequestCustDomain" :open.sync="openRequestCustDomain" :company="company")
      domain-verifications(v-if="openDomainVerifications" :open.sync="openDomainVerifications" :company="company")

</template>

<script>
import { mapActions } from 'vuex'
import UpdateWebhook from '@/components/dialogs/settings/UpdateWebhook.vue'
import RequestCustomDomain from '@/components/clinic/dialogs/RequestCustomDomain.vue'
import DomainVerifications from '@/components/dialogs/DomainVerifications.vue'

export default {
  name: 'AdvanceConfigurationSettings',
  components: { UpdateWebhook, RequestCustomDomain, DomainVerifications },
  props: ['company'],
  data () {
    return {
      showUpdateWebhookDialog: false,
      openRequestCustDomain: false,
      openDomainVerifications: false,
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    openLink (link) {
      if (link === 'w') {
        window.open('https://guide.yezza.io/eng/tips-use-webhook/')
      } else if (link === 'a' ) {
        window.open('https://help.yezza.io/hc/en-my/sections/900000600066-Analytics')
      } else if (link === 'p' ) {
        window.open('https://help.yezza.io/hc/en-my/categories/900000227246-Accept-Payments')
      } else {
        window.open('https://help.yezza.io/hc/en-my/articles/900003297906-How-To-Integrate-Yezza-With-WooCommerce-')
      }
    },
    openWebhookDialog () {
      this.showUpdateWebhookDialog = true
    },
  }
}
</script>

<i18n>
{
  "en": {
    "section_integrations": {
      "title": "Integrations",
      "desc": "Analytics, e-commerce integrations, domain, webhook",
      "analytics": "Analytics",
      "analytics_desc": "Analyze and measure your business performance",
      "ecommerce_integration": "E-commerce Integrations",
      "ecommerce_integration_desc": "Integrate with your current e-commerce system",
      "domain": "Domain",
      "domain_desc": "Manage your domain for Clinic Appointment Page",
      "custom_domain": "Custom Domain",
      "domain_verifications": "Domain Verifications",
      "webhook": "Webhook",
      "webhook_desc": "Webhook setting for API integration"
    },
    "section_shipping": {
      "title": "Shipping and delivery",
      "desc": "Manage zones, courier and on-demand integrations",
      "manage_shipping": "Manage shipping & delivery methods by zones",
      "manage_shipping_desc": "Manage shipping & delivery methods by zones",
      "manage_shipping_disabled": "Shipping and delivery integrations are disabled because Yezza Shipping is activated.",
      "courier_integration": "Courier Integration",
      "courier_integration_desc": "Take advantage of courier services that can easily be integrated with your Yezza account",
      "ondemand": "On-Demand Delivery Integration",
      "ondemand_desc": "Take advantage of on-demand delivery services that can easily integrated with your Yezza account."
    },
    "courier_description": {
      "easyparcel": "Hub for major courier services like PosLaju, DHL etc.",
      "lalamove": "On-Demand service delivery in Malaysia",
      "zepto": "On-Demand service delivery in Malaysia"
    },
    "section_payment": {
      "title": "Payment",
      "desc": "Third party payment gateways",
      "payment_gateway": "Payment Gateway",
      "payment_gateway_desc": "Activate your choice of payment gateway"
    }
  },
  "id": {
    "section_integrations": {
      "title": "Integrasi",
      "desc": "Analisa, integrasi e-commerce, domain, webhook",
      "analytics": "Analisis",
      "analytics_desc": "Analisis dan ukur performa bisnis kamu",
      "ecommerce_integration": "Integrasi E-commerce",
      "ecommerce_integration_desc": "Integrasikan dengan sistem e-commerce kamu saat ini",
      "domain": "Domain",
      "domain_desc": "Atur domain kamu untuk Clinic Appointment Page",
      "custom_domain": "Domain Khusus",
      "domain_verifications": "Verifikasi Domain",
      "webhook": "Webhook",
      "webhook_desc": "Pengaturan Webhook untuk integrasi API"
    },
    "section_shipping": {
      "title": "Pengiriman",
      "desc": "Atur zona, kurir dan integrasi on-demand",
      "manage_shipping": "Atur shipping & delivery berdasarkan zona",
      "manage_shipping_desc": "Atur shipping & delivery berdasarkan zona",
      "manage_shipping_disabled": "Integrasi pengiriman dan pengiriman dinonaktifkan karena Yezza Shipping diaktifkan.",
      "courier_integration": "Integrasi Kurir",
      "courier_integration_desc": "Manfaatkan layanan kurir yang mudah diintegrasikan dengan akun Yezza kamu",
      "ondemand": "Integrasi Pengiriman Sesuai Permintaan",
      "ondemand_desc": "Manfaatkan layanan pengiriman sesuai permintaan yang dengan mudah diintegrasikan dalam akun Yezza kamu."
    },
    "courier_description": {
      "easyparcel": "Hub untuk layanan kurir utama seperti PosLaju, DHL dll.",
      "lalamove": "Pengiriman layanan sesuai permintaan di Malaysia",
      "zepto": "Pengiriman layanan sesuai permintaan di Malaysia"
    },
    "section_payment": {
      "title": "Pembayaran",
      "desc": "Portal Pembayaran Third Party",
      "payment_gateway": "Portal Pembayaran",
      "payment_gateway_desc": "Aktifkan portal pembayaran pilihan kamu"
    }
  }
}
</i18n>